import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AddQuestionComponent } from './components/add-question/add-question.component';
import { ListEvaluationComponent } from './components/list-evaluation/list-evaluation.component';
import { TemplateEvaluationComponent } from './components/template-evaluation/template-evaluation.component';
import { EsnEvaluationSentComponent } from './components/esn-evaluation-sent/esn-evaluation-sent.component';
import { PvEvaluationComponent } from './components/pv-evaluation/pv-evaluation.component';
import { AddTemplateComponent } from './components/add-template/add-template.component';
import { DetailsEvalComponent } from './components/details-eval/details-eval.component';
import { ListeEvaluateursComponent } from './components/liste-evaluateurs/liste-evaluateurs.component';
import { DetailsTemplateComponent } from './components/details-template/details-template.component';
import { EvalWegestuComponent } from './components/eval-wegestu/eval-wegestu.component';
import { DetailsEvalWegestuComponent } from './components/details-eval-wegestu/details-eval-wegestu.component';
import { DetailsEvalRecComponent } from './components/details-eval-rec/details-eval-rec.component';
import { DetailsPvComponent } from './components/pv-evaluation/details-pv/details-pv.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'reçus',
    pathMatch: 'full',
  },
  {
    path:'reçus',
    component:ListEvaluationComponent,
  },
  {
    path:'list',
    component:EsnEvaluationSentComponent,
  },
  {
    path:'ajout-question',
    component:AddQuestionComponent,
  },
  {
    path:'template-evaluation',
    component:TemplateEvaluationComponent,
  },
  {
    path:'pv',
    component:PvEvaluationComponent,
  },
  {
    path:'ajout-evaluation',
    component:AddTemplateComponent
  },
  {
    path:'details-evaluation',
    component:DetailsEvalComponent
  },
  {
    path:'liste-evaluateurs/:id',
    component:ListeEvaluateursComponent
  },
  {
    path:'details-template',
    component:DetailsTemplateComponent
  },
  {
    path:'evaluation-wegestu',
    component:EvalWegestuComponent
  },
  {
    path:'details-evaluation/:id',
    component:DetailsEvalWegestuComponent
  },
  {
    path:'details-eval-rec',
    component:DetailsEvalRecComponent
  },
  {
    path:'details-pv',
    component:DetailsPvComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EvaluationRoutingModule { }
